import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import ConnectButton from '@/pages/_banner/ConnectButton';
import Wrapper from '@/pages/_banner/Wrapper';
import useRouter from '@/hooks/useRouter';
import useDialogLauncher from '@/dialogs-routable/_hooks/useDialogLauncher';
import { DialogManager } from '@/dialogs_new/DialogManager';

ActiveBanner.propTypes = {
  creator: PropTypes.object.isRequired,
  event: PropTypes.object.isRequired
};

export default function ActiveBanner(props) {
  const { creator, event } = props;
  const { t } = useTranslation();

  const { history } = useRouter();
  const launch = useDialogLauncher();

  return (
    <Wrapper
      creator={creator}
      title={t('events.active_banner.title')}
      subtitle={t('events.active_banner.subtitle')}
    >
      <div className="flex flex-col sm:flex-row space-x-0 space-y-4 sm:space-x-4 sm:space-y-0">
        <ConnectButton outline={true} onClick={() => history.push('/invite-populate')}>
          {t('events.active_banner.find_partners')}
        </ConnectButton>
        <ConnectButton onClick={() => launch(DialogManager.EventShare.Config(event.id))}>
          {t('events.active_banner.share_event')}
        </ConnectButton>
      </div>
    </Wrapper>
  );
};
